import React, { useState, useEffect, useRef } from 'react';
import Logo from '../images/logoGrandePreta.jpg';
import { usePDF } from 'react-to-pdf';
import BotaoGerarPDF from './GerarPDFComReactPDF';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { FaRegFilePdf } from 'react-icons/fa';
import CryptoJS from 'crypto-js';

import {
	requestUsersCnes,
	requestNewUnits,
	requestNoteCreate,
	requestEmailSend,
	requestUnitSectors,
} from '../services/requests';
import Json from '../utils/tipos_incidentes.json';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import Cookies from 'js-cookie';

function NotifyForm() {
	const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
	const [otherCheck, setOtherCheck] = useState(false);
	const [yesCheck, setYesCheck] = useState(false);
	const [yesCheck2, setYesCheck2] = useState(false);
	const [formLayout, setFormLayout] = useState(false);
	const [noteCreated, setNoteCreated] = useState(false);
	const [unitSectors, setUnitSectors] = useState([]);
	const [showAlert, setShowAlert] = useState(false);
	const [enviado, setEnviado] = useState(false);
	const [copiado, setCopiado] = useState(false);
	const [protocolo, setProtocolo] = useState('');
	const [invalidFields, setInvalidFields] = useState([]);
	const [isPrinting, setIsPrinting] = useState(false);

	const secreto = process.env.REACT_APP_SECRET;

	const setores = [
		'ACOLHIMENTO COM CLASSIFICAÇÃO DE RISCO - ACCR',
		'AGÊNCIA TRANSFUSIONAL',
		'ALMOXARIFADO',
		'ALOJAMENTO CONJUNTO',
		'AMBULATÓRIO',
		'ANESTESIOLOGIA',
		'BANCO DE LEITE',
		'CASA D PUÉRPERA',
		'CENTRO CIRÚRGICO',
		'CENTRO DE ESTUDOS',
		'CENTRAL DE DISTRIBUIÇÃO DE MATERIAIS',
		'COMUNICAÇÃO',
		'CONTROLE DE ACESSO',
		'CENTRO DE PARTO NORMAL',
		'ENFERMARIA ACONCHEGO',
		'ENFERMARIA GESTANTE',
		'ENFERMARIA GINECOLÓGICA',
		'ENGENHARIA CLÍNICA',
		'FARMÁCIA',
		'FATURAMENTO',
		'FISIOTERAPIA',
		'FONOAUDIOLOGIA',
		'GINECOLOGIA',
		'HIGIENE',
		'HOSPITAL DIA',
		'HOTELARIA',
		'MANUTENÇÃO',
		'MATERNIDADE SEGURA',
		'NAIR',
		'NÚCLEO INTERNO DE REGULAÇÃO',
		'NUTRIÇÃO',
		'NÚCLEO DE VIGILÂNCIA EPIDEMIOLÓGICA HOSPITALAR',
		'OBSTETRÍCIA',
		'OUVIDORIA',
		'PATRIMÔNIO',
		'PSICOLOGIA',
		'QUALIDADE',
		'RECEPÇÃO',
		'RECURSOS HUMANOS',
		'SALA DE APOIO A AMAMENTAÇÃO',
		'SALA DE PARTO',
		'SALA DE VACINA',
		'SERVIÇO DE ARQUIVO MÉDICO E ESTATÍSTICO',
		'SERVIÇO DE CONTROLE DE INFECÇÃO HOSPITALAR',
		'SERVIÇO SOCIAL',
		'SERVIÇOS ESPECIALIZADOS EM ENGENHARIA DE SEGURANÇA E EM MEDICINA DO TRABALHO',
		'SUPERVISÃO DE ENFERMAGEM',
		'TERAPIA OCUPACIONAL',
		'TECNOLOGIA DA INFORMAÇÃO',
		'UTI NEONATAL',
		'UCINCA',
		'UCINCO',
	];

	const setoresAlbert = [
		'Centro Cirúrgico',
		'CME',
		'UTI Pediátrico',
		'UI Adulto',
		'UTI Adulto',
		'UCINCO (UTI Neonatal)',
		'UI Neonatal',
		'Centro Obstétrico',
		'Obstetrícia',
		'Cirurgia Ginecológica',
		'Enfermaria de RN',
		'UCINCA Canguru',
		'Cirurgia Geral',
		'Cirurgia Vascular',
		'Clínica Médica',
		'Clínica Médica',
		'Ortopedia',
		'Pediatria',
		'UI Pediátrica',
		'Cirurgia Pediátrica',
	];

	const [form, setForm] = useState({
		unidade_token_notificacao: '',
		data_notificacao: '',
		data_ocorrencia: '',
		unidade: '',
		setor: '',
		nome_paciente: '',
		sexo_paciente: '',
		nascimento_paciente: '',
		prontuario: '',
		notificador: '',
		fato_presenciado: false,
		tipo_incidente: '',
		turno: '',
		quem_presenciou: '',
		descricao_ocorrencia: '',
		acoes_imediatas: '',
		medida_preventiva: '',
		other_checked: false,
	});

	const handleSectors = async (id) => {
		if (id) {
			const sectors = await requestUnitSectors(id);

			setUnitSectors(sectors);
		}
	};

	const formRef = useRef(null);

	const handleCopy = (event) => {
		const content = event.target.value; // Conteúdo específico
		navigator.clipboard
			.writeText(content)
			.then(() => {
				setCopiado(true);
			})
			.catch((err) => {
				console.error('Erro ao copiar:', err);
			});
	};

	const [pdfBaixado, setPdfBaixado] = useState(false);

	const handleGeneratePDF = async () => {
		return new Promise((resolve) => {
			setIsPrinting(true);
			setFormLayout(true);

			const input = formRef.current;
			input.style.width = '1236px';
			input.style.minHeight = '1123px';

			setTimeout(() => {
				html2canvas(input, { scale: 2 }).then((canvas) => {
					const imgData = canvas.toDataURL('image/jpeg', 2);
					const pdf = new jsPDF('p', 'mm', 'a4');
					const pdfWidth = pdf.internal.pageSize.getWidth() - 2;
					const pdfHeight =
						(canvas.height * pdfWidth) / canvas.width - 12;

					pdf.addImage(
						imgData,
						'JPEG',
						0,
						0,
						pdfWidth,
						pdfHeight,
						undefined,
						'FAST'
					);

					// Criar um Blob e URL temporário
					const pdfBlob = pdf.output('blob');
					const pdfUrl = URL.createObjectURL(pdfBlob);
					document.cookie = `pdfUrl=${pdfUrl}; max-age=86400; path=/`;

					setTimeout(() => {
						setIsPrinting(false);
						input.style.width = '';
						input.style.minHeight = '';
						resolve();
					}, 100);
				});
			}, 500);
		});
	};

	// Função para baixar o PDF posteriormente
	const handleDownloadPDF = () => {
		const pdfUrl = getCookie('pdfUrl');
		if (pdfUrl) {
			const link = document.createElement('a');
			link.href = pdfUrl;
			link.download = `${form.unidade.split('-')}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	};

	// Função para recuperar cookie
	const getCookie = (name) => {
		const cookies = document.cookie.split('; ');
		const cookie = cookies.find((row) => row.startsWith(name));
		return cookie ? cookie.split('=')[1] : null;
	};

	const moment = require('moment');
	require('moment/locale/pt-br');
	moment.locale('pt-br');

	const incidentTypes = [
		'Falha na identificação do paciente',
		'Falha na terapia medicamentosa',
		'Falha na segurança cirúrgica',
		'Queda ou quase queda do paciente',
		'Lesão por pressão adquirida após admissão do paciente',
		'Reações transfusionais ou falhas com hemocomponentes',
		'Incidente envolvendo a dieta',
		'Falha no transporte/transferência do paciente',
		'Falha relacionada ao uso de gases/oxigênio/vapor',
		'Falha relacionada a exames e/ou diagnósticos',
		'Falha operacional de equipamentos ou dispositivos médicos',
		'Falha relacionada à infraestrutura, edifício ou instalações',
		'Falhas na comunicação e/ou documentação',
		'Contenção, suicídio ou dano autoinfligido',
		'Evasão de paciente',
	];

	const handleForm = (value, id) => {
		const findValueFromDisplay = (displayValue) => {
			let word = displayValue.trim();
			const result = Json.find((item) => item.display === word);
			return result ? result.value : '';
		};
		if (id === 'tipo_incidente' && otherCheck === false) {
			setForm((prevForm) => ({
				...prevForm,
				tipo_incidente: findValueFromDisplay(value),
			}));
		} else if (id === 'tipo_incidente' && otherCheck === true) {
			setForm((prevForm) => ({
				...prevForm,
				tipo_incidente: value,
			}));
		} else {
			setForm((prevForm) => ({ ...prevForm, [id]: value }));
		}
	};

	const isFormValid = () => {
		return Object.entries(form).every(([key, value]) => {
			if (key === 'nascimento_paciente') {
				return true; // Ignora a validação para este campo
			}
			let array = [
				'nome_paciente',
				'sexo_paciente',
				'nascimento_paciente',
				'quem_presenciou',
				'notificador',
				'prontuario',
			];

			if (yesCheck === true) {
				array = array.filter(
					(item) =>
						item !== 'nome_paciente' &&
						item !== 'sexo_paciente' &&
						item !== 'nascimento_paciente'
				);
			}
			if (yesCheck2 === true) {
				array = array.filter((item) => item !== 'quem_presenciou');
			}

			return array.includes(key) || value !== '';
		});
	};

	const handleSubmit = async () => {
		setForm((prevForm) => ({ ...prevForm, other_checked: otherCheck }));

		const requiredFields = [
			'data_ocorrencia',
			'turno',
			'setor',
			'descricao_ocorrencia',
			'acoes_imediatas',
			'medida_preventiva',
			'tipo_incidente',
			...(yesCheck
				? [
						'nome_paciente',
						'sexo_paciente',
						'nascimento_paciente',
						'prontuario',
				  ]
				: []),
		];

		const emptyFields = requiredFields.filter((field) => {
			const value = form[field]?.trim() || '';
			const isTooShort =
				[
					'descricao_ocorrencia',
					'acoes_imediatas',
					'medida_preventiva',
				].includes(field) && value.length < 3;
			return value === '' || isTooShort;
		});

		if (emptyFields.length > 0) {
			setInvalidFields(emptyFields);
			setShowAlert(true);
			return;
		}

		try {
			if (isFormValid && invalidFields.length === 0) {
				const result = await requestNoteCreate({
					...form,
					turno: form.turno
						.toUpperCase()
						.normalize('NFD')
						.replace(/[̀-ͯ]/g, ''),
					data_notificacao: moment().format('YYYY-MM-DD'),
					envolve_paciente: yesCheck,
				});

				if (result.error) {
					console.error(result.error);
					return;
				} else {
					setProtocolo(result.protocolo);
					setNoteCreated(true);

					if (form.unidade_token_notificacao && result.protocolo) {
						const cnes = form.unidade_token_notificacao
							.split('')
							.reverse()
							.join('');
						const prodToken =
							'fde906a07d4d922f954d1761177855d233850f45';
						const users = await requestUsersCnes(prodToken, cnes);
						if (users) {
							const emails = users
								.filter((user) =>
									user.perfil_unidades.some(
										(unidade) =>
											unidade.unidade_id.replace(
												/-/g,
												''
											) === cnes &&
											unidade.ativo &&
											(unidade.groups.includes(
												'Gestores'
											) ||
												unidade.groups.includes(
													'Classificadores'
												))
									)
								)
								.map((user) => user.email)
								.filter((email) => email);

							await requestEmailSend(prodToken, {
								template_id: 1,
								destinatarios: emails.length > 0 ? emails : [],
								variaveis: { protocolo: result.protocolo },
							});
						}
					}
				}

				await handleGeneratePDF();
				setEnviado(true); // Aguarda a geração do PDF antes de concluir o envio
				console.log('Formulário enviado');
			}
		} catch (error) {
			console.error('Erro no envio:', error);
		}
	};

	const setUnitToken = async () => {
		const units = await requestNewUnits();

		// Extrai o nome da unidade após "notificacoes/"
		const unitName = decryptName(
			decodeURIComponent(
				String(window.location.pathname).split('notificacoes/')[1]
			)
		);

		// Encontra a unidade correspondente no array
		const unit = units.find((unit) => unitName === unit.nome);

		// Atualiza o estado com o token da unidade
		if (unit) {
			handleSectors(unit.id);
			setForm((prevForm) => ({
				...prevForm,
				unidade_token_notificacao: unit.id
					.replace(/-/g, '')
					.split('')
					.reverse()
					.join(''),
			}));
		}
	};

	const decryptName = (encodedName) => {
		const decoded = atob(encodedName); // Decodifica de volta para o nome original
		return decoded;
	};

	useEffect(() => {
		setForm((prevForm) => ({
			...prevForm,
			data_notificacao: moment(new Date()).format('DD/MM/YYYY'),
			unidade: decryptName(
				decodeURIComponent(
					String(window.location.pathname).split('notificacoes/')[1]
				)
			),
		}));
		setUnitToken();
	}, []);

	return (
		<div>
			{enviado ? (
				<div className='font-inter flex justify-center items-start w-[80%] mx-auto h-screen'>
					<div className='flex flex-col  bg-[#F5F5F5] mt-[100px]  items-center rounded-md  max-w-[800px] gap-5 flex-grow shadow-lg'>
						<div className='bg-[#004A80]  rounded-t-md  w-full h-[20px] '>
							{' '}
						</div>
						<div className='text-[#00C0F3]   '>
							<IoMdCheckmarkCircle className='size-[50px] sm:size-[100px]' />
						</div>
						<div className='text-3xl font-semibold text-[#004A80]'>
							{' '}
							Notificação Enviada com Sucesso{' '}
						</div>
						<div className='text-lg font-medium  w-[80%] text-[#8b8b8b]'>
							{' '}
							Sua Notificação foi enviada para a equipe de
							classificação, acompanhe o andamento dela através do
							protocolo abaixo.{' '}
						</div>
						<div className='flex flex-col sm:text-4xl font-bold mt-2 sm:mt-[32px] text-[#004A80]'>
							<div className='flex gap-3'>
								<div>Protocolo: </div>
								<button
									onClick={(event) => handleCopy(event)}
									value={protocolo}
									className=''>
									{protocolo}
									{/* {' '}
									{Math.floor(Math.random() * 1000000)} */}
								</button>
							</div>
							{copiado ? (
								<div className='flex flex-col justify-end '>
									<div className='text-[#a0a0a0] font-semibold text-end  text-[12px]'>
										Protocolo copiado!
									</div>
								</div>
							) : null}
						</div>
						<p className='text-xs sm:text-lg mx-auto text-center sm:text-start text-[#a0a0a0] mt-4  '>
							Clique no botão abaixo para baixar o PDF da sua
							notificação
						</p>
						<button
							className='sm:w-35 flex items-center justify-center gap-2 border border-[#B74644] text-[#B74644] p-1 sm:py-2 sm:px-4 rounded-md hover:bg-[#B74644] hover:text-white transition-all duration-200 text-[10px] sm:text-base focus:outline-none cursor-pointer sm:mb-[40px]'
							onClick={() => {
								handleDownloadPDF();
								setPdfBaixado(true);
							}}>
							{pdfBaixado ? (
								'Download Concluído'
							) : (
								<>
									<FaRegFilePdf className='scale-[130%] text-[10px]' />
									Baixar PDF
								</>
							)}
						</button>

						<a
							className='text-[#00C0F3] text-[10px] sm:text-base mb-14 hover:text-[#004A80] transition-all duration-200'
							href='/hub-de-notificacoes'>
							{' '}
							voltar à consulta de protocolos
						</a>
					</div>
				</div>
			) : (
				<div
					ref={formRef}
					id='my-table-id'
					className='mx-auto w-full max-w-[1130px] mt-10 px-4 sm:px-6 lg:px-8'>
					<div
						className={`${
							formLayout
								? 'flex flex-row justify-between w-full h-[150px] my-1'
								: 'flex flex-col md:flex-row justify-between w-full h-[190px] sm:h-[150px]  my-1'
						}`}>
						<div
							className={`${
								formLayout
									? 'w-[40%] h-[105px] my-3 flex justify-start'
									: 'w-0 md:w-[30%] h-[105px] my-3 flex justify-center md:justify-start'
							}`}>
							<img
								alt='logo da prefeitura'
								src={Logo}
								className={`${
									formLayout
										? 'h-[80%] mt-6 scale-75 object-contain'
										: 'h-full scale-75 object-contain'
								}`}
							/>
						</div>
						<div
							className={`${
								formLayout
									? 'w-[65%] h-auto my-5 text-white font-bold text-center flex items-center justify-center relative'
									: 'w-full md:w-[65%] min-h-[105px] my-5 text-white font-bold text-center flex items-center justify-center relative'
							}`}>
							<p
								className={`${
									formLayout
										? 'text-2xl md:text-3xl bg-gray-800 w-full px-2 py-2'
										: 'text-xl md:text-2xl lg:text-3xl bg-gray-800 w-full px-4 py-4'
								}`}>
								NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
							</p>
						</div>
					</div>
					<div className='w-full border-[1px] md:border-[0px] border-black'>
						<div className='w-full  md:border-[1px] border-black'>
							<div
								className={`${
									formLayout
										? 'flex flex-row'
										: 'flex flex-col md:flex-row'
								}`}>
								{/* Data da Notificação */}
								<div className='flex w-full justify-between md:w-1/2 sm:border-r-[1px] border-b border-black px-2 py-3 items-center'>
									<p className='font-semibold text-md md:text-base w-3/12 sm:w-4/12 text-start whitespace-nowrap'>
										Data da notificação:
									</p>
									<div className='w-4/12 sm:w-4/12 text-sm md:text-base focus:outline-none'>
										{form.data_notificacao}
									</div>
								</div>

								{/* Data da Ocorrência */}
								<div className='flex w-full justify-between md:w-1/2 border-b-[1px] border-black px-2 py-3 items-center'>
									<p className='font-semibold text-md md:text-base w-3/12 sm:w-4/12 text-start whitespace-nowrap'>
										Data da ocorrência:
									</p>
									{formLayout ? (
										<div>
											{form.data_ocorrencia
												? form.data_ocorrencia
														.split('-')
														.reverse()
														.join('/')
												: ''}
										</div>
									) : (
										<input
											name='data_ocorrencia'
											id='data_ocorrencia'
											type='date'
											max={
												new Date()
													.toISOString()
													.split('T')[0]
											}
											onChange={({
												target: { value, id },
											}) => {
												handleForm(value, id);

												// Remove a borda vermelha ao digitar
												setInvalidFields((prev) =>
													prev.filter(
														(field) => field !== id
													)
												);
											}}
											className={`text-sm md:text-base focus:outline-none rounded-md px-2 py-1 border ${
												invalidFields.includes(
													'data_ocorrencia'
												)
													? 'border-red-500'
													: 'border-gray-300'
											}`}
										/>
									)}
								</div>

								<div
									className={`flex w-full justify-between md:w-1/2 px-3 py-3 items-center duration-300 transition-all
    ${
		invalidFields.includes('turno')
			? 'border-2 border-red-400 '
			: 'border-b border-black sm:border-l-[1px]'
	} 
  `}>
									{/* Turno */}
									<p className='font-semibold text-md md:text-base w-3/12 sm:w-2/12 text-start whitespace-nowrap ml-2'>
										Turno:
									</p>
									{formLayout ? (
										<div className='w-full flex justify-start'>
											{form.turno}
										</div>
									) : (
										<div className='flex flex-row sm:flex-col lg:flex-row gap-4 duration-300 transition-all'>
											{['Manhã', 'Tarde', 'Noite'].map(
												(turno) => (
													<label
														key={turno}
														className='flex items-center gap-2 text-sm md:text-base duration-300 transition-all'>
														<input
															type='radio'
															name='turno'
															value={turno}
															checked={
																form.turno ===
																turno
															}
															onChange={({
																target: {
																	value,
																	name,
																},
															}) => {
																handleForm(
																	value,
																	name
																);
																setInvalidFields(
																	(prev) =>
																		prev.filter(
																			(
																				field
																			) =>
																				field !==
																				'turno'
																		)
																);
															}}
															className='focus:outline-none'
														/>
														{turno}
													</label>
												)
											)}
										</div>
									)}
								</div>
							</div>

							<div
								className={`${
									formLayout
										? 'flex flex-row'
										: 'flex flex-col md:flex-row'
								}`}>
								<div className='flex w-full md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'>
									<p className='font-semibold content-center align-baseline py-1'>
										Unidade:
									</p>
									<input
										disabled
										name='unidade'
										id='unidade'
										defaultValue={form.unidade}
										className='w-[100%] ml-2 focus:outline-none bg-white'
										type='text'
									/>
								</div>
								<div
									className={`${
										formLayout
											? 'w-7/12 border-b-[1px] flex border-black px-2 py-3 items-center'
											: 'w-full md:w-7/12 flex border-b-[1px] border-black px-2 py-3 items-center'
									}`}>
									<p className='font-semibold text-start py-1 whitespace-nowrap mr-4'>
										Setor onde ocorreu o incidente:
									</p>
									{formLayout ? (
										<div className='w-full flex justify-start'>
											{requestUnitSectors.setor}
										</div>
									) : (
										<select
											name='setor'
											id='setor'
											onChange={({
												target: { value, id },
											}) => {
												handleForm(value, id);
												setInvalidFields((prev) =>
													prev.filter(
														(field) =>
															field !== 'setor'
													)
												); // Remove a borda vermelha ao selecionar
											}}
											className={`w-5/12 sm:w-5/12 h-8 border rounded-md px-2 py-1 focus:outline-none transition duration-200 bg-white
        ${
			invalidFields.includes('setor')
				? 'border-1 border-red-400'
				: 'border-gray-250 focus:border-[#004A80]'
		}
      `}>
											<option
												key={''}
												value={''}>
												Setores
											</option>
											{(form.unidade ===
											'Hospital Municipal Albert Schweitzer'
												? setoresAlbert
												: setores
											).map((set) => (
												<option
													key={set}
													value={set}>
													{set}
												</option>
											))}
										</select>
									)}
								</div>
							</div>

							<div
								className={`sm:flex p-3 ${
									invalidFields.includes('nome_paciente')
										? 'border-2 border-red-400 '
										: 'border-b border-black  '
								} `}>
								<div className='w-full py-2 sm:flex gap-3'>
									<p className='font-semibold px-2 content-center md:w-5/12 text-start'>
										O fato foi relacionado a um paciente?
									</p>
									<div className='w-full flex items-center px-2 gap-4'>
										{/* Botão de rádio "Não" */}
										<label className='flex items-center'>
											<input
												type='radio'
												name='nome_paciente'
												defaultChecked='true'
												onChange={({
													target: { id, name },
												}) => {
													handleForm(id, name);
													setYesCheck(false);
													setForm((prev) => ({
														...prev,
														nome_paciente: '',
														sexo_paciente: '',
														nascimento_paciente: '',
														prontuario: '',
													}));
													setInvalidFields((prev) =>
														prev.filter(
															(field) =>
																field !==
																'nome_paciente'
														)
													);
													// Remove campo da lista de inválidos
												}}
												className='form-radio h-4 w-4 text-blue-600'
											/>

											<span
												className={`${
													formLayout
														? 'ml-2 text-gray-700 mb-2'
														: 'ml-2 text-gray-700'
												}`}>
												Não
											</span>
										</label>

										{/* Botão de rádio "Sim" */}
										<label className='flex items-center w-full font-semibold'>
											<input
												type='radio'
												name='nome_paciente'
												id='sim'
												onChange={() => {
													setYesCheck(true);
													setInvalidFields((prev) =>
														prev.filter(
															(field) =>
																field !==
																'nome_paciente'
														)
													); // Remove campo da lista de inválidos
												}}
												className='form-radio h-4 w-4 text-blue-600'
											/>
											<span className='ml-2 text-gray-700 flex w-full items-center'>
												<span
													className={`${
														formLayout
															? ' text-gray-700 w-3/12 text-start py-2 mb-2'
															: ' text-gray-700 md:w-3/12 text-start py-2'
													}`}>
													Sim?
												</span>
												{yesCheck &&
													(isPrinting ? (
														// Renderiza o nome como div ao gerar o PDF
														<div className='w-full h-8 text-md p-2 text-gray-700'>
															{form.nome_paciente ||
																'Nome não informado'}
														</div>
													) : (
														// Exibe o input no formulário
														<input
															type='text'
															id='nome_paciente'
															placeholder='Escreva o nome'
															value={
																form.nome_paciente
															}
															onChange={({
																target: {
																	value,
																	id,
																},
															}) => {
																handleForm(
																	value,
																	id
																);
																setInvalidFields(
																	(prev) =>
																		prev.filter(
																			(
																				field
																			) =>
																				field !==
																				'nome_paciente'
																		)
																);
															}}
															className={`w-full h-8 text-md focus:outline-none p-2 
          ${
				invalidFields.includes('nome_paciente')
					? 'border-b-2 border-red-400'
					: 'border-b-[1px] border-gray-400'
			}`}
														/>
													))}
											</span>
										</label>
									</div>
								</div>
							</div>

							<div
								className={`${
									formLayout
										? 'w-full flex flex-row'
										: 'w-full flex flex-col md:flex-row'
								}`}>
								{/* Campo Sexo */}
								<div
									className={`flex w-full justify-between md:w-1/2 px-3 py-3 items-center
    ${
		invalidFields.includes('sexo_paciente')
			? formLayout
				? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
				: ` ${
						!yesCheck
							? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
							: 'border-r-2 border-b-2 border-l-2 border-red-400'
				  }`
			: 'border-b sm:border-l-[0px] sm:border-r-[1px] border-black'
	} ${!yesCheck ? 'opacity-50' : ''}`}>
									<p className='font-semibold text-start mr-2 content-start'>
										Sexo:
									</p>
									<div className='flex gap-4'>
										<label className='flex items-center py-1'>
											<input
												type='radio'
												name='sexo_paciente'
												id='masculino'
												checked={
													form.sexo_paciente ===
													'masculino'
												}
												onChange={({
													target: { id, name },
												}) => {
													handleForm(id, name);
													setInvalidFields((prev) =>
														prev.filter(
															(field) =>
																field !==
																'sexo_paciente'
														)
													);
												}}
												className='h-4 w-4 text-blue-600'
												disabled={!yesCheck}
											/>
											<span className='ml-2 text-sm'>
												Masculino
											</span>
										</label>
										<label className='flex items-center py-1'>
											<input
												type='radio'
												name='sexo_paciente'
												id='feminino'
												checked={
													form.sexo_paciente ===
													'feminino'
												}
												onChange={({
													target: { id, name },
												}) => {
													handleForm(id, name);
													setInvalidFields((prev) =>
														prev.filter(
															(field) =>
																field !==
																'sexo_paciente'
														)
													);
												}}
												className='h-4 w-4 text-blue-600'
												disabled={!yesCheck}
											/>
											<span className='ml-2 text-sm'>
												Feminino
											</span>
										</label>
									</div>
								</div>

								{/* Campo Data de Nascimento */}
								<div
									className={`flex w-full justify-between md:w-1/2 px-3 py-3 items-center
    ${
		invalidFields.includes('nascimento_paciente')
			? formLayout
				? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
				: ` ${
						!yesCheck
							? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
							: 'border-r-2 border-b-2 border-l-[1px] sm:border-l-[0px] border-red-400'
				  }`
			: 'border-b sm:border-l-[0px]  sm:border-r-[1px] border-black'
	} ${!yesCheck ? 'opacity-50' : ''}`}>
									<p className='font-semibold text-md md:text-base text-start whitespace-nowrap'>
										Data de Nascimento:
									</p>
									{formLayout ? (
										<div>
											{form.nascimento_paciente
												? form.nascimento_paciente
														.split('-')
														.reverse()
														.join('/')
												: ''}
										</div>
									) : (
										<input
											name='nascimento_paciente'
											id='nascimento_paciente'
											value={
												form.nascimento_paciente || ''
											}
											onChange={({
												target: { value, id },
											}) => {
												if (
													!value ||
													!isNaN(
														new Date(
															value
														).getTime()
													)
												) {
													handleForm(value, id);
												} else {
													console.error(
														'Data inválida'
													);
												}
											}}
											max={
												new Date()
													.toISOString()
													.split('T')[0]
											}
											type='date'
											className='text-sm md:text-base focus:outline-none'
											disabled={!yesCheck}
										/>
									)}
								</div>

								{/* Campo Prontuário */}
								<div
									className={`flex w-full justify-between md:w-1/2 px-3 py-3 items-center
    ${
		invalidFields.includes('prontuario')
			? formLayout
				? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
				: ` ${
						!yesCheck
							? 'border-b  sm:border-l-[1px] border-r-[1px] border-black'
							: 'border-r-2 border-b-2 border-l-[1px] sm:border-l-[0px] border-red-400'
				  }`
			: 'border-b  sm:border-l-[0px] sm:border-r-[0px] border-black'
	} ${!yesCheck ? 'opacity-50' : ''}`}>
									<p className='whitespace-nowrap font-semibold py-1 text-start sm:text-center'>
										Prontuário/BE:
									</p>
									{formLayout || !yesCheck ? (
										<div>{form.prontuario}</div>
									) : (
										<input
											placeholder='no maximo 10 digitos'
											maxLength={10}
											name='prontuario'
											id='prontuario'
											onChange={({
												target: { value, id },
											}) => handleForm(value, id)}
											className='ml-1 w-full focus:outline-none border-b-[1px] sm:border-0 border-gray-400 focus:border-[#004A80] transition duration-200'
											type='text'
											disabled={!yesCheck}
										/>
									)}
								</div>
							</div>

							<div
								className={`${
									formLayout
										? 'flex w-full sm:flex border-black px-2 py-3'
										: 'w-full md:w-full sm:flex border-black px-2 py-3'
								}`}>
								<p
									className={`${
										formLayout
											? 'font-semibold  content-center text-start py-1 w-[400px]'
											: 'font-semibold  content-center text-start py-1 sm:w-[400px]'
									}`}>
									Identificação do notificador (Opcional):
								</p>
								{formLayout ? (
									<div>{form?.prontuario}</div>
								) : (
									<input
										name='notificador'
										id='notificador'
										onChange={({ target: { value, id } }) =>
											handleForm(value, id)
										}
										className='ml-1 w-full focus:outline-none border-b-[1px] sm:border-0 border-gray-400 focus:border-[#004A80] transition duration-200'
										type='text'
									/>
								)}
							</div>
						</div>
					</div>
					<div className='w-full my-5 border-[1px] border-black'>
						<div className='w-full bg-gray-300 py-2 text-center font-bold '>
							INCIDENTES E NÃO CONFORMIDADES
						</div>
						<div
							className={`w-full border-b-[1px] border-t border-black p-4  ${
								invalidFields.includes('tipo_incidente')
									? 'border-2 border-red-400' // Borda vermelha aplicada
									: ''
							} ${
								invalidFields.includes('tipo_incidente')
									? 'border-2 border-red-400' // Borda vermelha aplicada
									: ''
							}`} // Distanciamento da borda vermelha
						>
							<div
								className={`${
									formLayout
										? 'grid grid-cols-2 gap-4'
										: 'grid grid-cols-1 lg:grid-cols-2 gap-4'
								}`}>
								{incidentTypes.map((incident, index) => (
									<label
										key={index}
										className='flex items-center whitespace-nowrap'>
										<input
											type='radio'
											name='tipo_incidente'
											value={incident}
											id={incident}
											onChange={({
												target: { value, name },
											}) => {
												setForm((prevForm) => ({
													...prevForm,
													other_checked: false,
												}));
												handleForm(value, name);
												setInvalidFields((prev) =>
													prev.filter(
														(field) =>
															field !==
															'tipo_incidente'
													)
												); // Remove erro se preenchido
											}}
											className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
										/>
										<span
											className={`${
												formLayout
													? 'ml-2 text-gray-700 mb-2 text-base '
													: 'ml-2 text-gray-700 text-sm md:text-base text-wrap flex text-start'
											}`}>
											{incident}
										</span>
									</label>
								))}
								<label className='flex items-center whitespace-nowrap'>
									<input
										type='radio'
										name='tipo_incidente'
										onChange={({ target: { checked } }) => {
											setOtherCheck(checked);
											setForm((prevForm) => ({
												...prevForm,
												tipo_incidente: '',
												other_checked: checked,
											}));

											if (!checked) {
												setInvalidFields((prev) =>
													prev.filter(
														(field) =>
															field !==
															'tipo_incidente'
													)
												); // Remove erro se "Outro" não for selecionado
											}
										}}
										className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
									/>
									<span className='ml-2 text-gray-700 flex items-center w-10/12 text-sm md:text-base'>
										Outro:
										{otherCheck ? (
											<input
												type='text'
												name='tipo_incidente'
												onChange={({
													target: { value, name },
												}) => {
													handleForm(value, name);
												}}
												className={`ml-2 w-full h-8 text-xs md:text-sm border-b-[1px] border-gray-500  px-2 focus:outline-none ${
													invalidFields.includes(
														'tipo_incidente'
													) && formLayout === false
														? 'border-2 border-red-400 rounded-md'
														: ''
												}`}
											/>
										) : null}
									</span>
								</label>
							</div>
						</div>

						<div
							className={`sm:flex p-3 ${
								invalidFields.includes('nome_paciente')
									? 'border-2 border-red-400 '
									: ' border-black '
							} `}>
							<div className='w-full py-2 sm:flex gap-3'>
								<p className='font-semibold px-2 content-center md:w-5/12 text-start'>
									O fato foi presenciado por alguém?
								</p>
								<div className='w-full flex items-center px-2 gap-4'>
									{/* Botão de rádio "Não" */}
									<label className='flex items-center'>
										<input
											type='radio'
											name='quem_presenciou'
											defaultChecked='true'
											id='nao'
											onChange={({
												target: { id, name },
											}) => {
												handleForm(id, name);
												setYesCheck2(false);
												setForm((prevForm) => ({
													...prevForm,
													fato_presenciado: false,
												}));
												setInvalidFields((prev) =>
													prev.filter(
														(field) =>
															field !==
															'quem_presenciou'
													)
												); // Remove campo da lista de inválidos
											}}
											className='form-radio h-4 w-4 text-blue-600'
										/>
										<span
											className={`${
												formLayout
													? 'ml-2 text-gray-700 mb-2'
													: 'ml-2 text-gray-700'
											}`}>
											Não
										</span>
									</label>

									{/* Botão de rádio "Sim" */}
									<label className='flex items-center w-full font-semibold'>
										<input
											type='radio'
											name='quem_presenciou'
											id='sim'
											onChange={() => {
												setYesCheck2(true);
												setForm((prevForm) => ({
													...prevForm,
													fato_presenciado: true,
												}));
												setInvalidFields((prev) =>
													prev.filter(
														(field) =>
															field !==
															'quem_presenciou'
													)
												); // Remove campo da lista de inválidos
											}}
											className='form-radio h-4 w-4 text-blue-600'
										/>
										<span className='ml-2 text-gray-700 flex w-full items-center'>
											<span
												className={`${
													formLayout
														? ' text-gray-700 w-3/12 text-start py-2 mb-2'
														: ' text-gray-700 md:w-3/12 text-start py-2'
												}`}>
												Sim?
											</span>
											{yesCheck2 &&
												(isPrinting ? (
													// Exibe o nome dentro de uma div se já estiver preenchido
													<div className='w-full h-8 text-md p-2 text-gray-700'>
														{form.quem_presenciou ||
															'Nome não informado'}
													</div>
												) : (
													<input
														type='text'
														id='quem_presenciou'
														placeholder='Escreva o nome'
														onChange={({
															target: {
																value,
																id,
															},
														}) => {
															handleForm(
																value,
																id
															);
															// Remove borda vermelha assim que começar a digitar
															setInvalidFields(
																(prev) =>
																	prev.filter(
																		(
																			field
																		) =>
																			field !==
																			'quem_presenciou'
																	)
															);
														}}
														className={`w-full h-8 text-md focus:outline-none p-2 
                  ${
						invalidFields.includes('quem_presenciou')
							? 'border-b-2 border-red-400'
							: 'border-b-[1px] border-gray-400'
					}`}
													/>
												))}
										</span>
									</label>
								</div>
							</div>
						</div>
					</div>

					<div
						className={`w-full my-5 border rounded-md relative p-1 
    ${
		invalidFields.includes('descricao_ocorrencia')
			? 'border-red-400'
			: 'border-black'
	}`}>
						<div className='text-start px-2 font-semibold'>
							Descrição da ocorrência.
						</div>
						<textarea
							name='descricao_ocorrencia'
							id='descricao_ocorrencia'
							placeholder='Mínimo de 3 caracteres'
							onChange={({ target: { value, id } }) => {
								handleForm(value, id);

								setInvalidFields((prev) => {
									const updatedFields = prev.filter(
										(field) =>
											field !== 'descricao_ocorrencia'
									);

									if (
										id === 'descricao_ocorrencia' &&
										value.trim().length < 3
									) {
										return [
											...updatedFields,
											'descricao_ocorrencia',
										];
									}

									return updatedFields;
								});
							}}
							className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none rounded-md'></textarea>
					</div>
					<div
						className={`w-full my-5 border rounded-md relative p-1 
    ${
		invalidFields.includes('acoes_imediatas')
			? 'border-red-400'
			: 'border-black'
	}`}>
						<div className='text-start px-2 font-semibold'>
							Ações imediatas tomadas.
						</div>
						<textarea
							name='acoes_imediatas'
							id='acoes_imediatas'
							placeholder='Mínimo de 3 caracteres'
							onChange={({ target: { value, id } }) => {
								handleForm(value, id);

								setInvalidFields((prev) => {
									const updatedFields = prev.filter(
										(field) => field !== 'acoes_imediatas'
									);

									if (
										id === 'acoes_imediatas' &&
										value.trim().length < 3
									) {
										return [
											...updatedFields,
											'acoes_imediatas',
										];
									}

									return updatedFields;
								});
							}}
							className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none rounded-md'></textarea>
					</div>

					<div
						className={`w-full my-5 border rounded-md relative p-1 
    ${
		invalidFields.includes('medida_preventiva')
			? 'border-red-400'
			: 'border-black'
	}`}>
						<div className='text-start px-2 font-semibold'>
							Existe alguma medida em vigor para prevenir tal
							incidente? Qual?
						</div>
						<textarea
							name='medida_preventiva'
							id='medida_preventiva'
							placeholder='Mínimo de 3 caracteres'
							onChange={({ target: { value, id } }) => {
								handleForm(value, id);
								setInvalidFields((prev) => {
									const updatedFields = prev.filter(
										(field) => field !== 'medida_preventiva'
									);
									if (
										id === 'medida_preventiva' &&
										value.trim().length < 3
									) {
										return [
											...updatedFields,
											'medida_preventiva',
										];
									}
									return updatedFields;
								});
							}}
							className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none rounded-md'></textarea>
					</div>
					{/* Exibe a mensagem de alerta se o formulário for inválido */}
					<div className='flex mx-auto w-full sm:max-w-[1130px] mt-10 px-4 sm:px-6 lg:px-10 relative justify-end items-center flex-col sm:flex-row'>
						{/* Alerta de erro */}
						{(showAlert && !isFormValid()) ||
						invalidFields.length > 0 ? (
							<div className='text-red-500 font-semibold text-sm px-3 py-2 rounded-md mb-4 sm:mb-0 sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:top-0'>
								Preencha todos os campos obrigatórios.
							</div>
						) : null}
						{/* Botão de Enviar */}
						<button
							onClick={handleSubmit}
							disabled={noteCreated}
							className={`w-40 sm:w-40 py-2 px-4 rounded-md font-semibold focus:outline-none transition-all flex justify-center duration-200 border 
      ${
			isFormValid() && invalidFields.length === 0
				? 'enabled:bg-[#13335A] bg-[#396499] text-white enabled:hover:bg-[#0078B5] border-transparent'
				: 'bg-white text-gray-300 border-gray-300'
		}
      sm:px-6 sm:py-3 sm:ml-4 sm:mt-0 mt-4`}>
							{noteCreated ? (
								<svg
									aria-hidden='true'
									className='w-8 h-8 text-gray-200 animate-spin   fill-blue-600'
									viewBox='0 0 100 101'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
										fill='currentColor'
									/>
									<path
										d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
										fill='currentFill'
									/>
								</svg>
							) : (
								'Enviar'
							)}
						</button>
					</div>
				</div>
			)}

			{/* Alerta de campos obrigatórios */}
			{/* <button
					onClick={handleGeneratePDF}
					style={{ marginTop: '20px' }}>
					Gerar PDF
				</button> */}
			{/* <BotaoGerarPDF /> */}
		</div>
	);
}

export default NotifyForm;
